module.exports = __webpack_public_path__ + "img/sinImagen.17fd7fa9.jpg";